import tw from 'tailwind-styled-components'

export const TwForm = tw.div`
  flex
  flex-col
  gap-20
`

export const TwRow = tw.div`
  flex
  gap-8
  flex-col
`

export const TwFormInputError = tw.div`
  text-12
  text-status-error
`

export const TwFooter = tw.div`
  flex
  gap-12
  justify-end
`

export const TwWarningBlock = tw.div`
  flex
  flex-col
  py-10
`

export const TwWarningSign = tw.div<{$success?: boolean}>`
  flex
  items-center
  justify-center
  py-40
  px-24
  border-1
  border-solid
  border-transparent
  rounded-16
  text-generic-white
  text-20
  gap-4
  ${p => (p.$success ? 'bg-success' : 'bg-warning')}
`

export const TwWarningDescription = tw.div`
  flex
  flex-col
  gap-8
  mt-16
`

export const TwWarningTitle = tw.div`
  text-16
  text-primary
  font-semibold
`

export const TwWarningText = tw.div`
  text-primary
`
